import type { UseFormReturn } from "react-hook-form";
import type { FormSubmit } from "@shared-kernel/primary/shared/api-errors/action-form";
import type { FormInputs } from "./form-validation/user-password.schema";
import { PasswordInput } from "../../../shared/password-input/password-input.content";
import { Form } from "@shared-kernel/primary/shared/shadcn/ui/form";
import { ThemedButton } from "@shared-kernel/primary/shared/themed-button/themed-button";

interface Props {
  title: string;
  form: UseFormReturn<FormInputs>;
  onSubmit: FormSubmit;
  email: string;
}

export const PasswordForm = ({ title, form, onSubmit, email }: Props) => {
  const {
    watch,
    formState: { isDirty },
  } = form;

  return (
    <Form {...form}>
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="mt-3">
          <span>{title}</span>
          <br />
          <br />
          <span>{email}</span>
        </div>
        <PasswordInput control={form.control} password={watch("password")} />
        <div className="col-span-2 flex justify-end">
          <ThemedButton isDirty={isDirty} label="Enregistrer"></ThemedButton>
        </div>
      </form>
    </Form>
  );
};
